<div class="big-text">{{ statusMessage }}</div>
<div class="pictograms" *ngIf="tappingPenReady && !isRunning && !completed"><img src="assets/images/icons/Tapping_Test_Pictogram.svg" alt=""/></div>
<div class="pictograms" *ngIf="isRunning && !completed"><img src="assets/images/icons/Tapping_Test_Pictogram_repeat.svg" alt=""/></div>
